// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"8ac64673","796":"984ce188"}[chunkId] + ".chunk.js";
};